import { Permission } from "generated-graphql/graphql";
import { useAuthorization } from "hooks/useAuthorization";
import { useFacilityReadOnly } from "hooks/useFacilityReadOnly";

export type AttachDocumentAccess = {
  canAttach: boolean;
  /** Why the attach controls are disabled, for their tooltip; null while loading or allowed. */
  blockedReason: string | null;
};

/**
 * Whether the viewer may attach a file to a violation at `facilityId`. Attaching
 * creates a document at that facility, which the server allows only with
 * WriteDocument there and only while the facility isn't archived.
 */
export function useCanAttachViolationDocument(facilityId: string): AttachDocumentAccess {
  const { hasPermissionForFacility } = useAuthorization();
  // Read-only while the archived status loads, so the controls never enable early.
  const { isReadOnly, archivedAt } = useFacilityReadOnly(facilityId);
  if (!hasPermissionForFacility(facilityId, [Permission.WriteDocument])) {
    return {
      canAttach: false,
      blockedReason: "You don't have permission to upload documents at this facility.",
    };
  }
  if (archivedAt !== null) {
    return {
      canAttach: false,
      blockedReason: "This facility is archived, so documents can't be added.",
    };
  }
  return { canAttach: !isReadOnly, blockedReason: null };
}
